/** React Query keys of the vendor panel's store settings and team pages. */
export const storeKeys = {
  store: ["vendor", "store"] as const,
  addresses: ["vendor", "store", "addresses"] as const,
  bank: ["vendor", "store", "bank-accounts"] as const,
  team: ["vendor", "team"] as const,
};
